import {
  check,
  email,
  nonEmpty,
  pipe,
  regex,
  string,
  transform,
  trim,
} from "valibot";

export const EMAIL_REQUIRED_MESSAGE = "Email is required.";
export const EMAIL_INVALID_MESSAGE = "Enter a valid email address.";
export const PHONE_REQUIRED_MESSAGE = "Phone is required.";
export const PHONE_INVALID_MESSAGE = "Enter a valid phone number.";

const OPTIONAL_EMAIL_PATTERN = /^(?:$|[^\s@]+@[^\s@]+\.[^\s@]+)$/;
const INTERNATIONAL_PHONE_PATTERN = /^\+[1-9]\d{6,14}$/;

function isValidInternationalPhone(value: string) {
  return INTERNATIONAL_PHONE_PATTERN.test(value);
}

export function normalizePhone(input: string) {
  return input.trim().replace(/[().\s-]/g, "");
}

export const optionalEmailSchema = pipe(
  string(),
  trim(),
  regex(OPTIONAL_EMAIL_PATTERN, EMAIL_INVALID_MESSAGE)
);

export const requiredEmailSchema = pipe(
  string(),
  trim(),
  nonEmpty(EMAIL_REQUIRED_MESSAGE),
  email(EMAIL_INVALID_MESSAGE)
);

export const optionalPhoneSchema = pipe(
  string(),
  trim(),
  check(
    (value) => value === "" || normalizePhone(value) !== "",
    PHONE_INVALID_MESSAGE
  ),
  transform(normalizePhone),
  check(
    (value) => value === "" || isValidInternationalPhone(value),
    PHONE_INVALID_MESSAGE
  )
);

export const requiredPhoneSchema = pipe(
  string(),
  trim(),
  nonEmpty(PHONE_REQUIRED_MESSAGE),
  transform(normalizePhone),
  check(isValidInternationalPhone, PHONE_INVALID_MESSAGE)
);

export function getPhoneServerError(serverCode: string | undefined) {
  if (
    serverCode === "PAYMENT_WIDGET_PHONE_REQUIRED" ||
    serverCode === "SIGN_UP_WIDGET_PHONE_REQUIRED"
  ) {
    return PHONE_REQUIRED_MESSAGE;
  }
  if (
    serverCode === "PAYMENT_WIDGET_PHONE_INVALID" ||
    serverCode === "SIGN_UP_WIDGET_PHONE_INVALID"
  ) {
    return PHONE_INVALID_MESSAGE;
  }
}
